import { render, staticRenderFns } from "./3c_doc.vue?vue&type=template&id=15a774e9&scoped=true"
import script from "./3c_doc.vue?vue&type=script&lang=js"
export * from "./3c_doc.vue?vue&type=script&lang=js"
import style0 from "./3c_doc.vue?vue&type=style&index=0&id=15a774e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a774e9",
  null
  
)

export default component.exports